module.exports = __webpack_public_path__ + "img/hades.jpg.169be617.webp";